import { LOGGING_CONFIG } from '../../apps/bim-catastro/config/logging';

export const logger = {
  log: (category: keyof typeof LOGGING_CONFIG, message: string, ...args: any[]) => {
    if (LOGGING_CONFIG[category]) {
      console.log(message, ...args);
    }
  },
  
  warn: (category: keyof typeof LOGGING_CONFIG, message: string, ...args: any[]) => {
    if (LOGGING_CONFIG[category]) {
      console.warn(message, ...args);
    }
  },
  
  error: (category: keyof typeof LOGGING_CONFIG, message: string, ...args: any[]) => {
    if (LOGGING_CONFIG[category] || LOGGING_CONFIG.ERRORS) {
      console.error(message, ...args);
    }
  }
};
